import { createFileRoute } from "@tanstack/react-router";

import MobileApp from "/src/routes/settings/General/mobileApp/MobileApp";

export const Route = createFileRoute("/_main/settings/mobileApp")({
  component: MobileApp,
});
